import React, { useEffect, useState } from 'react';
import Inputmask from 'inputmask';
import Spacing from '../../Spacing';
import { Info, Loader, Plus, Trash} from 'lucide-react';
import { can_visit, getPractice, getSecureData, notify, setSecureData } from '../../../helpers';
import { checkValidSlug, fetchAllSpeciality, getOnboardPracticeData, updateOnboardPractice } from '../../../services/users';
import { useDocumentTitle } from '../../../hooks/customDocumentTitleHook';
import ConfirmationModal from '../../Modal/ConfirmationModal';
import Select from "react-select";
import { getActiveProductsData } from '../../../services/billing';

export default function Settings({selectedPracticeChange, fetchChangePracticeData}) {
  let location_id = getPractice("location_id");
  let account_id = getPractice("account_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
  }

  const [settingTab, setSettingTab] = useState(1);
  const [loading, setLoading] = useState(false);
  const [deleteLocation, setDeleteLocation] = useState(false);
  const [addLocationModal, setAddLocationModal] = useState(false);
  const [imgStatusCode, setImgStatusCode] = useState(null);
  const [deletedIndex, setDeletedIndex] = useState(0);
  const [chartingBilling, setChartingBilling] = useState([]);
  const [codingBilling, setCodingBilling] = useState([]);
  const [validSlug, setValidSlug] = useState("");
  const [slugCheckLoader, setSlugCheckLoader] = useState(false);
  const [disableUpdateButton, setDisableUpdateButton] = useState(true);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const defaultLocationValues = [{
    name: "", 
    website: "", 
    google_map_place_id: "",
    npi_number: null,
    phone: "",
    address1: "",
    city: "",
    state: "",
    zipcode: "",
    specialities: []
  }];
  const [locations, setLocations] = useState(defaultLocationValues);
  const [tempName, setTempName] = useState("");

  const defaultValues = {
    account_id: account_id,
    practice_name: "",
    alt_practice_name: "",
    email: "",
    // contact: "",
    // country: "",
    // city: "",
    // state: "",
    // street: "",
    // zip_code: "",
    medmo_api_key: "",
    emr_id: "",
    emr_type: "",
    appointment_slug: "",
    logo_link: "",
    appointment_notification_email: "",
    rejection_notification_email: "",
    locations: [],
    coding_price_type: "",
    charting_price_type: "",
    subscription_price: 300,
    account_type: "",
  }
  const [formData, setFormData] = useState(defaultValues);
  const [allSpeciality, setAllSpeciality] = useState([]);

  const [emrType] = useState([
    { value: 'ECW', label: 'ECW', },
    { value: 'MDLand', label: 'MDLand', },
    { value: 'VeradigmEHR', label: 'VeradigmEHR', },
    { value: 'AthenaHealth', label: 'AthenaHealth', }
  ]);

  const getAllSpeciality = async () => {
    try {
      const response = await fetchAllSpeciality();
      if (response?.data) {
        const allSpecialities = response?.data?.map((option) => ({
          value: option?.id,
          label: option?.name,
        }))
        setAllSpeciality(allSpecialities);
      };
    } catch (error) {
      // console.log("🚀 ~ getAllSpeciality: ~ error:", error);
    }
  };

  useEffect(() => {
    getAllSpeciality();
  }, []);

  useEffect(() => {
    fetchPracticeData();
    fetchActiveProducts();
    setValidSlug('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchActiveProducts = async () => {
    try {
      const response = await getActiveProductsData({
        location_id: location_id,
        account_id: account_id,
      });

      if (response?.data) {
        const charting_data = response?.data?.charting_billing?.map((items) => ({
          value: items?.price_nickname,
          label: items?.price_nickname+' - $'+items?.price_amount?.toFixed(2),
        }));
        setChartingBilling(charting_data);

        const coding_data = response?.data?.coding_billing?.map((items) => ({
          value: items?.price_nickname,
          label: items?.price_nickname+' - $'+items?.price_amount?.toFixed(2),
        }));
        setCodingBilling(coding_data);
      }
    } catch (error) {
      // console.log("🚀 ~ fetchActiveProducts ~ error:", error);
    }
  };

  const fetchPracticeData = async () => {
    setLoading(true);
    try {
      const response = await getOnboardPracticeData({
        location_id: location_id,
        account_id: account_id,
      });

      if (response) {
        const data = response?.data || {};
        setFormData({
          ...defaultValues,
          ...data,
          charting_price_type: data.charting_price_type || '',
          coding_price_type: data.coding_price_type || '',
          emr_type: data.emr_type || '',
          emr_id: data.emr_id || '',
          medmo_api_key: data.medmo_api_key || '',
          alt_practice_name: data.alt_practice_name || '',
          appointment_slug: data.appointment_slug || '',
          logo_link: data.logo_link || '',
          email: data.email || '',
          appointment_notification_email: data.appointment_notification_email || '',
          rejection_notification_email: data.rejection_notification_email || '',
          account_type: data.account_type || 'charting & portal',
        });
        setLocations(response?.data?.locations || defaultLocationValues);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "contact") {
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
        mask: '(999) 999-9999',
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }
    if (name === "subscription_price") {
      const price = parseInt(value, 10);
      setFormData({
        ...formData,
        [name]: isNaN(price) ? 0 : price,
      });
      setDisableUpdateButton(false);
      return;
    }
    if (name === "appointment_slug") {
      setValidSlug("");
      const lastChar = value.slice(-1);
      let formattedValue = value;
      if (lastChar === ' ') {
        formattedValue = value.slice(0, -1) + '-';
      }
      formattedValue = generateSlug(formattedValue);
      setFormData({
        ...formData,
        [name]: formattedValue,
      });
      setDisableUpdateButton(false);
      return;
    }
    setFormData({
      ...formData,
      [name]: value
    });
    setDisableUpdateButton(false);
  };

  useEffect(() => {
    checkImageURL(formData.logo_link);
  }, [formData]);

  const handleLogoCheck = (e) => {
    const { name, value } = e.target;
    
    checkImageURL(value);
    setFormData({
      ...formData,
      [name]: value
    });
    setDisableUpdateButton(false);
  };

  const checkImageURL = (img) => {
    setImgStatusCode(null);
    if(img !== "") {
      const regex = /\.(jpg|png|gif|jpeg)$/i;
      const match = img?.match(regex);

      if (!match) {
        setImgStatusCode('Error');
        return;
      }

      const LogoImg = new Image();
      LogoImg.onload = () => {
        setImgStatusCode(200);
      };
      LogoImg.onerror = () => {
        setImgStatusCode('Error');
      };
      LogoImg.src = img;
    }
  };

  const handleLocationChange = (index, e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
        mask: '(999) 999-9999',
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }

    const newLocations = [...locations];
    newLocations[index][name] = value;
    setLocations(newLocations);
    setDisableUpdateButton(false);
  };

  const handleTempNameChange = (e) => {
    setTempName(e.target.value);
    setDisableUpdateButton(false);
  };

  const handleNameBlur = (index) => {
    if (tempName.trim() !== "") {
      const newLocations = [...locations];
      newLocations[index].name = tempName;
      setLocations(newLocations);
    }
    setTempName("");
  };

  const addLocation = () => {
    setAddLocationModal(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const handleAddLocation = () => {
    setLocations([...locations, { name: "", website: "", google_map_place_id: "", npi_number: "", phone: "", address1: "", city: "", state: "", zipcode: "", specialities: [] }]);
  };

  const removeLocation = (index) => {
    setDeleteLocation(true);
    setDeletedIndex(index);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const handleDeleteRecord = async (id) => {
    if (locations.length > 1) {
      const newLocations = locations.filter((_, locIndex) => locIndex !== id);
      setLocations(newLocations);
    }
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      locations: locations
    }));
  }, [locations]);

  const checkSlug = async () => {
    setSlugCheckLoader(true);
    if(!formData?.appointment_slug){
      notify("error", 'Please provide a valid slug');
      return;
    }

    const slugCheckData = {
      account_id: account_id,
      appointment_slug: formData?.appointment_slug
    }

    try {
      const response = await checkValidSlug(slugCheckData);

      if (response?.detail) {
        notify('error', response?.detail);
        setValidSlug('');
        setSlugCheckLoader(false);
      } else {
        if(response?.data === true){
          setValidSlug(true);
        } else {
          setValidSlug(false);
        }
        setSlugCheckLoader(false);
      }
    } catch (error) {
      setValidSlug('');
      setSlugCheckLoader(false);
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    }
  };

  const handleUpdateSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      setDisableUpdateButton(true);
      e.target.disabled = true;

      const response = await updateOnboardPractice(formData);

      if (response.detail) {
        notify('error', response.detail);
      } else { 
        if(response.data.status === 'success'){
          notify("success", response.data.message);
          // fetchPracticeData();
          // setFormData(defaultValues);
          // setLocations(defaultLocationValues);
          let practiceInfo = await getSecureData('practiceInfo');
          if (practiceInfo) {
            practiceInfo.practice_email = formData.email;
            await setSecureData("practiceInfo", JSON.stringify(practiceInfo));
          }
        } else {
          notify("error", response.data.message);
        }
      }
    } catch (error) {
      // console.log("🚀 ~ handleUpdateSubmit ~ error:", error);
    } finally {
      setLoading(false);
      e.target.disabled = false;
    }
  };

  useEffect(() => {
    const sameAccount = formData.account_id === account_id;
    if (sameAccount) return;

    setFormData({
      ...formData,
      account_id: account_id,
      appointment_slug: "",
      logo_link: "",
    });
    setSettingTab(1);
    setLocations(defaultLocationValues);
    setValidSlug('');
    setImgStatusCode(null);
    fetchPracticeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location_id, account_id]);

  const handleSpecialityChange = (index, selectedOption) => {
    const selectedValues = selectedOption ? selectedOption.map((option) => option.value) : [];
  
    const newLocations = [...locations];
    newLocations[index].specialities = selectedValues;
    setLocations(newLocations);
    setDisableUpdateButton(false);
  };

  useDocumentTitle("Settings");

  return (
    <>
      <div className='docpro_settings_container'>
        <form onSubmit={handleUpdateSubmit} autoComplete="off" className="relative">
          <div className="docpro_tab_btns_2">
            <button
              type="button"
              className={`${settingTab === 1 ? "active" : ""}`}
              onClick={() => setSettingTab(1)}
            >
              Basic Information
            </button>
            <button
              type="button"
              className={`${settingTab === 2 ? "active" : ""}`}
              onClick={() => setSettingTab(2)}
            >
              Location Information
            </button>
          </div>
          <Spacing lg="30" sm="30" />

          {settingTab === 1 && (
            <>
              <div className='docpro_border_heading_card w-full'>
                <div className="card_heading">
                  <h1 className="mb-0 docpro_fs_18">Basic Information</h1>
                </div>

                <div className="card_body">
                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Practice Name <span className="docpro_red_color">*</span>
                      </label>
                      <input type="text" className="docpro_form_field size_lg docpro_ternary_color" name='practice_name' required readOnly value={formData.practice_name} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        ALT Practice Name
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='alt_practice_name' onChange={handleChange} readOnly={!can_visit("settings_basic_info_edit")} defaultValue={formData.alt_practice_name} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Email <span className="docpro_red_color">*</span>
                      </label>
                      <input type="email" className="docpro_form_field size_lg" name='email' required onChange={handleChange} readOnly={!can_visit("settings_basic_info_edit")} value={formData.email} />
                    </div>
                    {/* <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Contact
                      </label>
                      <input type="text" className="docpro_form_field size_lg us_phone" name='contact'
                        onChange={handleChange}
                        defaultValue={formData.contact}
                        maxLength={20} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Street
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='street' onChange={handleChange} defaultValue={formData.street} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        City
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='city' onChange={handleChange} defaultValue={formData.city} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        State
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='state' onChange={handleChange} defaultValue={formData.state} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Zip
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='zip_code' onChange={handleChange} defaultValue={formData.zip_code} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Country
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='country' onChange={handleChange} defaultValue={formData.country} />
                    </div> */}
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Medmo API Key
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='medmo_api_key' onChange={handleChange} readOnly={!can_visit("settings_basic_info_edit")} defaultValue={formData.medmo_api_key} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        EMR Type
                      </label>
                      <Select
                        name="emr_type"
                        options={emrType}
                        onChange={(selectedOption) => {
                          setFormData({ ...formData, emr_type: selectedOption.value });
                          setDisableUpdateButton(false);
                        }}
                        placeholder="Search..."
                        isSearchable={true}
                        value={emrType.find(
                          (option) => option.value === formData.emr_type
                        )}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '40px',
                            borderRadius: '8px',
                            borderColor: 'var(--border)',
                          }),
                        }}
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        EMR ID
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='emr_id' onChange={handleChange} readOnly={!can_visit("settings_basic_info_edit")} value={formData.emr_id || ''} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Appointment Slug {"  "}
                        {validSlug === true ? 
                          <span className="docpro_badge docpro_badge_cyan docpro_square">Available</span>
                        : validSlug === false ? 
                          <span className="docpro_badge docpro_badge_red docpro_square">Not Available</span>
                        :
                          ""
                        }
                      </label>
                      <div className="docpro_form_field_with_icon_group">
                        <div className="docpro_form_field static_text">book.doc.pro</div>
                        <input type="text" className="docpro_form_field size_lg" name='appointment_slug' placeholder='Slug' onChange={handleChange} readOnly={!can_visit("settings_basic_info_edit")} defaultValue={formData.appointment_slug} />
                        {can_visit("settings_basic_info_edit") && (
                          <div className="docpro_form_field check_text relative" onClick={() => checkSlug()}>
                            Check
                            {slugCheckLoader && (
                              <span className="docpro_loading" style={{ background: 'rgb(31 120 198)', cursor: 'auto' }}>
                                <Loader width={20} height={20} />
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_primary_color">
                        <span className='docpro_fw_500 mr-2'>Logo Link</span>
                        <button className="docpro_icon_btn overview" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                          <Info width={14} height={16} className='docpro_accent_color' />
                          <div className="docpro_tip" style={{ textTransform: 'unset' }}>
                            <span>
                              Accept file type: .jpg, .png, .gif <br />
                              Recommended width: 320px
                            </span>
                          </div>
                        </button>
                      </label>
                      <div className="flex items-center" style={{ justifyContent: 'between' }}>
                        <div className='w-full mr-2'>
                          <input type="url" className="docpro_form_field size_lg" name='logo_link' defaultValue={formData.logo_link} readOnly={!can_visit("settings_basic_info_edit")} onChange={handleLogoCheck} pattern="https?://.*" placeholder="https://doc.pro/logo.png" />
                        </div>
                        <div>
                          {imgStatusCode === null ? (
                            <img 
                              src="/images/logo.svg" 
                              alt="Logo" 
                              style={{ maxHeight: '30px', width: '100%', maxWidth: '180px' }}
                            />
                          ) : imgStatusCode === 200 ? (
                            <img 
                              src={formData.logo_link} 
                              alt="Logo"
                              style={{ maxHeight: '30px', width: '100%', maxWidth: '180px' }}
                            />
                          ) : (
                            <p className='docpro_fs_14 docpro_mb_0 docpro_red_color' style={{ width: '100px' }}>Provide Valid URL</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {can_visit("administrator") && (
                    <>
                      <Spacing lg="16" sm="22" />
                      <div className="docpro_portal_use">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Why do you want to use our portal?
                        </label>
                        <div className="docpro_radio_group">
                          <div className="docpro_radio">
                            <input
                              type="radio"
                              name="account_type"
                              onChange={handleChange}
                              checked={formData.account_type === "charting"}
                              value="charting"
                            />
                            <label style={{ paddingLeft: "30px" }}>Charting</label>
                          </div>
                          <div className="docpro_radio">
                            <input
                              type="radio"
                              name="account_type"
                              onChange={handleChange}
                              checked={formData.account_type === "charting & portal"}
                              value="charting & portal"
                            />
                            <label style={{ paddingLeft: "30px" }}>Charting & Portal</label>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <Spacing lg="30" sm="30" />
              <div className='docpro_border_heading_card w-full'>
                <div className="card_heading">
                  <h1 className="mb-0 docpro_fs_18">Notification Information</h1>
                </div>

                <div className="card_body">
                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Appointment Notification Email
                      </label>
                      <input type="email" className="docpro_form_field size_lg" name='appointment_notification_email' onChange={handleChange} readOnly={!can_visit("settings_basic_info_edit")} defaultValue={formData.appointment_notification_email} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Rejection Notification Email
                      </label>
                      <input type="email" className="docpro_form_field size_lg" name='rejection_notification_email' onChange={handleChange} readOnly={!can_visit("settings_basic_info_edit")} defaultValue={formData.rejection_notification_email} />
                    </div>
                  </div>
                </div>
              </div>

              {can_visit("administrator") && (
                <>
                  <Spacing lg="30" sm="30" />
                  <div className='docpro_border_heading_card w-full'>
                    <div className="card_heading">
                      <h1 className="mb-0 docpro_fs_18">Billing Configuration</h1>
                    </div>

                    <div className="card_body">
                      <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Charting Charge <small>(Per Item)</small>
                          </label>
                          <Select
                            name="charting_price_type"
                            options={chartingBilling}
                            onChange={(selectedOption) => {
                              setFormData({ ...formData, charting_price_type: selectedOption.value });
                              setDisableUpdateButton(false);
                            }}
                            placeholder="Search..."
                            isSearchable={true}
                            value={chartingBilling.find(
                              (option) => option.value === formData.charting_price_type
                            )}
                            className="react-select-container w-full"
                            classNamePrefix="react-select"
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '40px',
                                borderRadius: '8px',
                                borderColor: 'var(--border)',
                              }),
                            }}
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Coding Charge <small>(Per Item)</small>
                          </label>
                          <Select
                            name="coding_price_type"
                            options={codingBilling}
                            onChange={(selectedOption) => {
                              setFormData({ ...formData, coding_price_type: selectedOption.value });
                              setDisableUpdateButton(false);
                            }}
                            placeholder="Search..."
                            isSearchable={true}
                            value={codingBilling.find(
                              (option) => option.value === formData.coding_price_type
                            )}
                            className="react-select-container w-full"
                            classNamePrefix="react-select"
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '40px',
                                borderRadius: '8px',
                                borderColor: 'var(--border)',
                              }),
                            }}
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Subscription Fee
                          </label>
                          <input type="number" className="docpro_form_field size_lg" name='subscription_price' onChange={handleChange} readOnly={!can_visit("settings_basic_info_edit")} value={formData?.subscription_price} />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <Spacing lg="30" sm="30" />
              <hr />
              <Spacing lg="32" sm="32" />
              {can_visit("settings_basic_info_edit") && (
                <div className="docpro_modal_btns">
                  <button
                    className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg`}
                    style={{ pointerEvents: `${(loading || disableUpdateButton) ? "none" : "initial"}` }}
                    type="submit"
                    disabled = {disableUpdateButton ? true : false}
                  >
                    Update
                    {loading && (
                      <span className="docpro_loading">
                        <Loader width={20} height={20} />
                      </span>
                    )}
                  </button>
                </div>
              )}
            </>
          )}

          {settingTab === 2 && (
            <>
              {locations.map((location, index) => (
                <div key={index}>

                  <div className='docpro_border_heading_card w-full'>
                    <div className="card_heading flex items-center" style={{ justifyContent: 'space-between' }}>
                      <h1 className="mb-0 docpro_fs_18">Location Configuration</h1>
                      {(locations.length > 1 && can_visit("settings_location_info_edit")) && (
                        <div className="docpro_icon_btns">
                          <button
                            type="button"
                            onClick={() => removeLocation(index)}
                            className="docpro_icon_btn docpro_icon_btn_red last_btn_tip"
                          >
                            <Trash width={20} height={20} />
                            <span className="docpro_tip">Remove Location</span>
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="card_body">
                      <div className={`docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3 w-full rounded-md`}>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Practice Location <span className="docpro_red_color">*</span>
                          </label>
                          <input 
                            type="text" 
                            name='name' 
                            className={`docpro_form_field size_lg ${location.name !== "" && 'docpro_ternary_color'}`} 
                            value={location.name || tempName} 
                            required 
                            readOnly={location.name !== "" && !can_visit("settings_location_info_edit")} 
                            onChange={location.name === "" ? handleTempNameChange : undefined}
                            onBlur={() => handleNameBlur(index)} 
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Website URL
                          </label>
                          <input 
                            type="url"
                            className="docpro_form_field size_lg"
                            name='website'
                            defaultValue={location?.website}
                            readOnly={!can_visit("settings_location_info_edit")}
                            onChange={(e) => handleLocationChange(index, e)}
                            pattern="https?://.*"
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Google Map Place ID
                          </label>
                          <input
                            type="text"
                            className="docpro_form_field size_lg"
                            name='google_map_place_id'
                            defaultValue={location?.google_map_place_id}
                            readOnly={!can_visit("settings_location_info_edit")}
                            onChange={(e) => handleLocationChange(index, e)}
                          />
                        </div>

                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            NPI Number
                          </label>
                          <input 
                            type="text"
                            className="docpro_form_field size_lg"
                            name='npi_number'
                            minLength={10}
                            maxLength={10}
                            defaultValue={location?.npi_number}
                            readOnly={!can_visit("settings_location_info_edit")}
                            onChange={(e) => handleLocationChange(index, e)}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            }}
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Phone
                          </label>
                          <input 
                            type="text"
                            className="docpro_form_field size_lg us_phone"
                            name='phone'
                            defaultValue={location?.phone}
                            maxLength={20}
                            readOnly={!can_visit("settings_location_info_edit")}
                            onChange={(e) => handleLocationChange(index, e)}
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Address
                          </label>
                          <input 
                            type="text"
                            className="docpro_form_field size_lg"
                            name='address1'
                            defaultValue={location?.address1}
                            readOnly={!can_visit("settings_location_info_edit")}
                            onChange={(e) => handleLocationChange(index, e)}
                          />
                        </div>

                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            City
                          </label>
                          <input 
                            type="text"
                            className="docpro_form_field size_lg"
                            name='city'
                            defaultValue={location?.city}
                            readOnly={!can_visit("settings_location_info_edit")}
                            onChange={(e) => handleLocationChange(index, e)}
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            State
                          </label>
                          <input 
                            type="text"
                            className="docpro_form_field size_lg"
                            name='state'
                            defaultValue={location?.state}
                            readOnly={!can_visit("settings_location_info_edit")}
                            onChange={(e) => handleLocationChange(index, e)}
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Zip Code
                          </label>
                          <input 
                            type="text"
                            className="docpro_form_field size_lg"
                            name='zipcode'
                            defaultValue={location?.zipcode}
                            readOnly={!can_visit("settings_location_info_edit")}
                            onChange={(e) => handleLocationChange(index, e)}
                          />
                        </div>
                      </div>
                      <Spacing lg="20" sm="20" />
                      <div>
                        <label className="docpro_fw_500 docpro_primary_color">
                          Specialities
                        </label>
                        <Select
                          isMulti
                          name="specialities"
                          options={allSpeciality}
                          placeholder="Search..."
                          isSearchable
                          value={allSpeciality?.filter((option) => 
                            location.specialities?.includes(option.value)
                          ) || []}
                          onChange={(selectedOption) => handleSpecialityChange(index, selectedOption)}
                          className="react-select-container w-full"
                          classNamePrefix="react-select"
                          filterOption={(option, rawInput) => {
                            const words = rawInput.toLowerCase().split(" ");
                            return words.every((word) =>
                              option.label.toLowerCase().includes(word)
                            );
                          }}
                          isDisabled={!can_visit("settings_location_info_edit")}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: '40px',
                              borderColor: 'var(--border)',
                              borderRadius: '8px'
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 1050,
                              marginTop: '-2px',
                              borderRadius: '0 0 3px 3px',
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 1050,
                              padding: 0
                            }),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <Spacing lg="25" sm="25" />
                </div>
              ))}
              {can_visit("administrator") && (
                <>
                  <button 
                    type="button"
                    onClick={addLocation} 
                    className="docpro_bordered_btn location docpro_fw_600 size_lg w-full" 
                  >
                    <Plus width={20} height={20} />
                    <span>Add a new location</span>
                  </button>
                  <Spacing lg="25" sm="25" />
                </>
              )}
              <hr />
              <Spacing lg="32" sm="32" />
              {can_visit("settings_location_info_edit") && (
                <div className="docpro_modal_btns">
                  <button
                    className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg`}
                    style={{ pointerEvents: `${(loading || disableUpdateButton) ? "none" : "initial"}` }}
                    type="submit"
                    disabled = {disableUpdateButton ? true : false}
                  >
                    Update
                    {loading && (
                      <span className="docpro_loading">
                        <Loader width={20} height={20} />
                      </span>
                    )}
                  </button>
                </div>
              )}
            </>
          )}

          {loading && (
            <div className="absolute top-0 left-0 w-full" style={{ height: '100%', zIndex: 3 }}>
              <div className="flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', background: 'rgb(255 255 255 / 63%)' }}>
                <span className="docpro_loading" style={{ position: 'inherit' }}>
                  <Loader width={46} height={46} style={{ color: 'var(--accent)' }} />
                </span>
              </div>
            </div>
          )}
        </form>
      </div>

      {deleteLocation && (
        <ConfirmationModal
          actionType={() => handleDeleteRecord(deletedIndex)}
          openModal={deleteLocation}
          setOpenModal={setDeleteLocation}
          name={'this location'}
          type={'delete'}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {addLocationModal && (
        <ConfirmationModal
          actionType={() => handleAddLocation()}
          openModal={addLocationModal}
          setOpenModal={setAddLocationModal}
          name={'add a new location'}
          type={'add'}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {/* <div className="docpro_support_wrap">
        <label className="docpro_fw_500 docpro_primary_color">Name</label>
        <input
          type="text"
          className="docpro_form_field size_lg"
          placeholder="Add emails"
        />
        <Spacing lg="25" sm="25" />
        <label className="docpro_fw_500 docpro_primary_color">Email</label>
        <input
          type="email"
          className="docpro_form_field size_lg"
          placeholder="example@gmail.com"
          disabled
        />
        <Spacing lg="25" sm="25" />
        <label className="docpro_fw_500 docpro_primary_color">Gender</label>
        <select className="docpro_form_field size_lg">
          <option value="1">Male</option>
          <option value="2">Female</option>
          <option value="3">Others</option>
        </select>
        <Spacing lg="25" sm="25" />
        <label className="docpro_fw_500 docpro_primary_color">Role</label>
        <select className="docpro_form_field size_lg">
          <option value="3">Admin</option>
          <option value="4">User</option>
        </select>
        <Spacing lg="25" sm="25" />
        <label className="docpro_fw_500 docpro_primary_color">About Me</label>
        <textarea
          rows="5"
          cols="6"
          className="docpro_form_field size_lg"
        ></textarea>
        <Spacing lg="25" sm="25" />
        <Button filled lg>
          Update
        </Button>
      </div> */}
    </>
  );
}